export const AltLabel = {
  Logo: 'NZQA logo click to navigate to the home page',
  FooterLogo: 'New Zealand Government'
};
